import { Loader2, FileText } from "lucide-react";

interface ConversionPendingPlaceholderProps {
  status?: "pending" | "processing" | "failed";
  onRetry?: () => void;
}

export function ConversionPendingPlaceholder({
  status = "processing",
  onRetry,
}: ConversionPendingPlaceholderProps) {
  if (status === "failed") {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-4 text-muted-foreground">
        <FileText className="h-12 w-12 text-destructive" />
        <p className="text-lg font-medium">Conversion Failed</p>
        <p className="text-sm">We couldn't convert this document to PDF.</p>
        {onRetry && (
          <button
            onClick={onRetry}
            className="mt-2 rounded-md bg-primary px-4 py-2 text-sm text-primary-foreground hover:bg-primary/90"
          >
            Try Again
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 text-muted-foreground">
      <div className="relative">
        <FileText className="h-12 w-12" />
        <Loader2 className="absolute -bottom-1 -right-1 h-6 w-6 animate-spin text-primary" />
      </div>
      <p className="text-lg font-medium">
        {status === "pending" ? "Preparing document..." : "Converting to PDF..."}
      </p>
      <p className="text-sm">This may take a moment</p>
    </div>
  );
}
